export default "__VITE_ASSET__32bf60af__"